import { FormControl, FormHelperText, InputLabel, OutlinedInput } from "@mui/material";
import { forwardRef } from "react";
import { IMaskInput } from "react-imask";
import { fieldValueToString } from "../../utils/react_hook_form_input_utils";


/**
 * PercentageMaskedInputBase
 */

interface CustomProps {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  mask: string;
}

const PercentageMaskedInputBase = forwardRef<HTMLInputElement, CustomProps>((props, refs) => {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      placeholderChar="_"
      inputRef={refs}
      onAccept={(value: any, input: { unmaskedValue: string }) => {
        if (input.unmaskedValue.length > 0) {
          onChange({ target: { name: props.name, value } });
        } else {
          onChange({ target: { name: props.name, value: '' } });
        }
      }}
      lazy={false}
      overwrite={true}
      unmask={true}
    />
  );
});

/**
 * PercentageMaskedInput
 */

type Props = {
  name: string;
  label: string;
  value: number | null;
  required?: boolean;
  disabled?: boolean;
  helperText?: string;
  onChangeValue: (value: number | null) => void;
  onBlur?: () => void;
};

export const PercentageMaskedInput = ({
  name,
  label,
  value,
  required,
  disabled,
  helperText,
  onChangeValue,
  onBlur,
}: Props) => {
  return (
    <FormControl variant="outlined" size="small">
      <InputLabel
        htmlFor={`input-${name as string}`}
        error={helperText !== undefined && helperText !== null}
        shrink={true}
        size="small"
        required={required}>
        {label}
      </InputLabel>

      <OutlinedInput
        size="small"
        id={`input-${name as string}`}
        name={name as string}
        label={label}
        notched={true}
        required={required}
        disabled={disabled}
        aria-describedby={`${name as string}-component-error-text`}
        inputComponent={PercentageMaskedInputBase as any}
        value={fieldValueToString(value)}
        onChange={e => e.target.value ? onChangeValue(Number(e.target.value)) : null}
        onBlur={onBlur}
        inputProps={{
          mask: [
            { mask: '\\0,\\0\\0 %', lazy: true },
            { mask: '\\0,\\00 %', lazy: false },
            { mask: '\\0,00 %', lazy: false },
            { mask: '0,00 %', lazy: false },
            { mask: '00,00 %', lazy: false },
            { mask: '000,00 %', lazy: false },
          ],
          placeholder: "___,__ %",
          required: required,
        }} />

      <FormHelperText id={`${name as string}-component-error-text`} error={helperText !== undefined && helperText !== null}>
        {helperText}
      </FormHelperText>
    </FormControl>
  );
}